import { useLazyQuery } from '@apollo/client';
import { exportXlsModal } from 'motion-components';
import { gqlGetQueryExcel } from '../graphql';
import { buildWhereFromFilterValues } from './filters';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const exportColumns = (t) => {
  return [
    { fieldName: 'id', fieldTitle: t('ID'), fieldType: 'TEXT' },
    { fieldName: 'identificationDocument', fieldTitle: t('Κωδικός Εντύπου'), fieldType: 'TEXT' },

    { fieldName: 'edocSeries.name', fieldTitle: t('Σειρά Εντύπου Αναγνώρισης'), fieldType: 'TEXT' },
    { fieldName: 'idocPrefix', fieldTitle: t('Κωδικός ΕΑΕΑ'), fieldType: 'TEXT' },
    { fieldName: 'idocNumber', fieldTitle: t('Αριθμός ΕΑΕΑ'), fieldType: 'TEXT' },
    { fieldName: 'isMulti', fieldTitle: t('Σύνθετο Δρομολόγιο'), fieldType: 'BOOLEAN' },
    { fieldName: 'wasteOriginType.name', fieldTitle: t('Προέλευση Αποβλήτων'), fieldType: 'TEXT' },
    { fieldName: 'dateCollected', fieldTitle: t('Ημ/νία & Ώρα Παραλαβής'), fieldType: 'DATETIME' },
    { fieldName: 'region.name', fieldTitle: t('Περιφέρεια'), fieldType: 'TEXT' },
    {
      fieldName: 'collectionPointName',
      fieldTitle: t('Επωνυμία'),
      fieldType: 'TEXT',
    },
    { fieldName: 'colpointAddressLine1', fieldTitle: t('Διεύθυνση'), fieldType: 'TEXT' },
    { fieldName: 'colpointAddressLine2', fieldTitle: t('Διεύθυνση (γραμμή 2)'), fieldType: 'TEXT' },
    { fieldName: 'colpointVatNumber', fieldTitle: t('Α.Φ.Μ.'), fieldType: 'TEXT' },
    { fieldName: 'colpointImaCode', fieldTitle: t('ΑΜ. ΗΜΑ'), fieldType: 'TEXT' },
    { fieldName: 'colpointTaxOffice', fieldTitle: t('Δ.Ο.Υ.'), fieldType: 'TEXT' },
    {
      fieldName: 'colpointCategory.name',
      fieldTitle: t('Κατηγορία'),
      fieldType: 'TEXT',
    },
    {
      fieldName: 'colpointAddressArea',
      fieldTitle: t('Περιοχή'),
      fieldType: 'TEXT',
    },
    { fieldName: 'colpointPostalCode', fieldTitle: t('Τ.Κ.'), fieldType: 'TEXT' },
    { fieldName: 'colpointAddressCity', fieldTitle: t('Πόλη'), fieldType: 'TEXT' },
    {
      fieldName: 'colpointPhoneNumber',
      fieldTitle: t('Τηλέφωνο'),
      fieldType: 'TEXT',
    },

    // Waste type and weight fields
    { fieldName: 'material.name', fieldTitle: t('Χαρακτηριστικά Αποβλήτων'), fieldType: 'TEXT' },
    { fieldName: 'ekaCode', fieldTitle: t('ΕΚΑ'), fieldType: 'TEXT' },
    { fieldName: 'unClass', fieldTitle: t('Κλάση UN'), fieldType: 'TEXT' },
    { fieldName: 'grossWeight', fieldTitle: t('Μικτό Βάρος Φορτίου (kg)'), fieldType: 'FLOAT' },
    { fieldName: 'tareWeight', fieldTitle: t('Απόβαρο Συσκευασίας (kg)'), fieldType: 'FLOAT' },
    { fieldName: 'contactPerson', fieldTitle: t('Υπεύθυνος'), fieldType: 'TEXT' },

    // idocExtra
    { fieldName: 'idocExtras', fieldTitle: t('Πρόσθετα Στοιχεία Συσκευασιών'), fieldType: 'TEXT' },

    // Collector / Transporter information
    { fieldName: 'collectorCompanyName', fieldTitle: t('Συλλέκτης'), fieldType: 'TEXT' },
    {
      fieldName: 'collectorCompanyAddress',
      fieldTitle: t('Διεύθυνση Συλλέκτη'),
      fieldType: 'TEXT',
    },
    {
      fieldName: 'collectorCompanyPhoneNumber',
      fieldTitle: t('Τηλέφωνο Συλλέκτη'),
      fieldType: 'TEXT',
    },
    {
      fieldName: 'collectorCompanyImaCode',
      fieldTitle: t('ΑΜ. ΗΜΑ'),
      fieldType: 'TEXT',
    },
    { fieldName: 'collectorCompanyVat', fieldTitle: t('Α.Φ.Μ. Συλλέκτη'), fieldType: 'TEXT' },
    { fieldName: 'collectorCompanyTaxOffice', fieldTitle: t('Δ.Ο.Υ. Συλλέκτη'), fieldType: 'TEXT' },
    { fieldName: 'driverFullName', fieldTitle: t('Οδηγός'), fieldType: 'TEXT' },
    { fieldName: 'adrNumber', fieldTitle: t('Αρ. Αδείας Οδηγού ADR'), fieldType: 'TEXT' },
    { fieldName: 'vehPlateNumber', fieldTitle: t('Όχημα'), fieldType: 'TEXT' },
    {
      fieldName: 'altRouteDescription',
      fieldTitle: t('Διαδρομή (άλλη από την πλέον βέλτιστη)'),
      fieldType: 'TEXT',
    },

    // Waste reception point fields
    {
      fieldName: 'wastereceptionpointCompanyName',
      fieldTitle: t('Σημείο Παραλαβής Αποβλήτων'),
      fieldType: 'TEXT',
    },
    {
      fieldName: 'dateStorage',
      fieldTitle: t('Ημ/νία & Ώρα Παράδοσης Αποβλήτων'),
      fieldType: 'DATETIME',
    },
    {
      fieldName: 'wasteDestinationType.name',
      fieldTitle: t('Κατηγορία Τελικού Αποδέκτη'),
      fieldType: 'TEXT',
    },
    {
      fieldName: 'wastereceptionpointCompanyAddress',
      fieldTitle: t('Διεύθυνση Παραλαβής Αποβλήτων'),
      fieldType: 'TEXT',
    },
    {
      fieldName: 'wastereceptionpointCompanyImaCode',
      fieldTitle: t('ΑΜ. ΗΜΑ Παραλαβής Αποβλήτων'),
      fieldType: 'TEXT',
    },
    {
      fieldName: 'wastereceptionpointCompanyVat',
      fieldTitle: t('Α.Φ.Μ. Παραλαβής Αποβλήτων'),
      fieldType: 'TEXT',
    },
    {
      fieldName: 'wastereceptionpointCompanyPhoneNumber',
      fieldTitle: t('Τηλέφωνο Παραλαβής Αποβλήτων'),
      fieldType: 'TEXT',
    },
    {
      fieldName: 'wastereceptionpointCompanyRegion.name',
      fieldTitle: t('Περιφέρεια Παραλαβής Αποβλήτων'),
      fieldType: 'TEXT',
    },
    {
      fieldName: 'receptionNetWeight',
      fieldTitle: t('Βάρος Φορτίου (κιλά)'),
      fieldType: 'TEXT',
    },
    {
      fieldName: 'wastereceptionpointCompanyTaxOffice',
      fieldTitle: t('Δ.Ο.Υ.'),
      fieldType: 'TEXT',
    },
    {
      fieldName: 'receptionPersonName',
      fieldTitle: t('Υπεύθυνος'),
      fieldType: 'TEXT',
    },
    {
      fieldName: 'wastereceptionpointCompanyEmail',
      fieldTitle: t('Email'),
      fieldType: 'TEXT',
    },
    {
      fieldName: 'firstDate',
      fieldTitle: t('Ημερομηνία Καταχώρησης'),
      fieldType: 'DATE',
    },
  ];
};

export function useGetQuery(): any {
  const { t } = useTranslation();
  const [get, { loading }] = useLazyQuery(gqlGetQueryExcel, { onCompleted: transformData });
  const [result, setResult] = useState<any>([get, { loading, data: undefined }]);
  function transformData(data) {
    const recs = data.getIdocs.data.map((values) => {
      return {
        ...values,
        isMulti: !values.isActive ? t('ΟΧΙ') : t('ΝΑΙ'),
        idocExtras: values.idocExtras
          ?.filter((extra) => extra.containersQty || extra.containerTareWeight)
          .map(
            (extra) =>
              `${extra.containertype?.name ? extra.containertype.name : ''} ${
                extra.containersQty ? `- ${extra.containersQty} τεμ` : ''
              } ${extra.containerTareWeight ? `, Βάρος: ${extra.containerTareWeight}` : ''}`,
          )
          .join('\n'),
      };
    });
    const trsData = {
      getIdocs: { data: recs, recordCount: data?.getIdocs?.recordCount },
    };
    setResult([get, { loading, data: trsData }]);
  }
  return result;
}

export async function handleExport(client, queryState: any, t): Promise<void> {
  const filterVariables = {
    where: buildWhereFromFilterValues(queryState?.filterValues),
  };
  await exportXlsModal({
    apolloClient: client,
    exportFileName: 'export Idocs',
    getLazyQuery: useGetQuery,
    columnsDef: exportColumns(t),
    filterVariables: filterVariables,
  });
}
